import { login } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/cookies'

const state = {
  token: getToken() || ''
}

const getters = {
  isLoggedIn: (state: any) => !!state.token
}

const mutations = {
  SET_TOKEN(state: any, token: string) {
    state.token = token
  }
}

const actions = {
  async login({ commit }: any, user: any) {
    let { email, password } = user
    email = email.trim()
    const { data } = await login({ email, password })
    setToken(data.access_token)
    commit('SET_TOKEN', data.access_token)
  },

  async logout({ commit }: any) {
    removeToken()
    commit('SET_TOKEN', '')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
